import { createSlice } from "@reduxjs/toolkit";
import { getAllAudithLogin } from "./hospitalAuditThunks";

interface HospitalAuditState {
  data: any[];
  loading: boolean;
  error: string | null;
}

const initialState: HospitalAuditState = {
  data: [],
  loading: false,
  error: null,
};

const hospitalAuditSlice = createSlice({
  name: "hospitalAudit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllAudithLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllAudithLogin.fulfilled, (state, action) => {
        state.loading = false;
        // ✅ FIX HERE
        state.data = action.payload?.data || [];
      })
      .addCase(getAllAudithLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) ?? "Failed to fetch data";
      });
  },
});

export default hospitalAuditSlice.reducer;
